import { render } from "./AreaCodeAudioUpload.vue?vue&type=template&id=6468816e"
import script from "./AreaCodeAudioUpload.vue?vue&type=script&lang=js"
export * from "./AreaCodeAudioUpload.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Express\\北方\\Agent_SYSTEM\\AgentWeb\\Vue\\agentweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__